<template>
  <div class="resume-filters mb-3">
    <!-- Botões de status -->
    <div class="status-buttons mb-2">
      <button
        type="button"
        class="btn status-btn status-btn-all"
        :class="{ 'is-active': filters.status === '' }"
        @click="setStatus('')"
      >
        Todos
      </button>
      <button
        v-for="s in statusOptions"
        :key="s"
        type="button"
        class="btn status-btn"
        :class="[`status-btn-${statusColorClass(s)}`, { 'is-active': filters.status === s }]"
        @click="setStatus(s)"
      >
        {{ statusFormat.status(s) }}
      </button>
    </div>

    <!-- Botões de período (filtra pela data da próxima ação: entrega/retirada/coleta/devolução) -->
    <div class="period-buttons mb-2">
      <button
        type="button"
        class="btn period-btn"
        :class="{ 'is-active': filters.period === '' }"
        @click="setPeriod('')"
      >
        Todos
      </button>
      <button
        type="button"
        class="btn period-btn"
        :class="{ 'is-active': filters.period === 'today' }"
        @click="setPeriod('today')"
      >
        Hoje
      </button>
      <button
        type="button"
        class="btn period-btn"
        :class="{ 'is-active': filters.period === 'week' }"
        @click="setPeriod('week')"
      >
        Essa semana
      </button>
    </div>

    <!-- Buscas -->
    <div class="row g-2">
      <div class="col-6">
        <input
          type="text"
          class="form-control"
          v-model="filters.city"
          placeholder="Cidade"
        />
      </div>
      <div class="col-6">
        <input
          type="text"
          class="form-control"
          v-model="filters.client"
          placeholder="Cliente"
        />
      </div>
    </div>
  </div>
</template>

<script>
import statusFormat from '@/services/statusFormat';
import { statusColorClass } from '@/utils/statusColor';

export default {
  name: 'ResumeFilters',
  props: {
    filters: { type: Object, required: true },
    statusOptions: { type: Array, default: () => [] }
  },
  setup(props) {
    function setStatus(status) {
      props.filters.status = status;
    }
    function setPeriod(period) {
      props.filters.period = period;
    }
    return { statusFormat, setStatus, setPeriod, statusColorClass };
  }
}
</script>

<style scoped>
.status-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.status-btn {
  flex: 1 1 45%;
  min-width: 44px;
  min-height: 44px;
  font-size: 0.9rem;
  font-weight: 600;
  white-space: nowrap;
  border-width: 2px;
  background: #fff;
  transition: all 0.15s ease-in-out;
}

.status-btn-all {
  border-color: #6c757d;
  color: #6c757d;
}
.status-btn-all.is-active {
  background: #6c757d;
  color: #fff;
}

.period-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.period-btn {
  flex: 1 1 auto;
  min-width: 44px;
  min-height: 38px;
  font-size: 0.85rem;
  font-weight: 600;
  white-space: nowrap;
  border-width: 2px;
  background: #fff;
  border-color: #378ADD;
  color: #378ADD;
  transition: all 0.15s ease-in-out;
}
.period-btn.is-active {
  background: #378ADD;
  border-color: #378ADD;
  color: #fff;
}

/* Cor por status: borda/texto quando inativo, gradiente quando ativo.
   Valores vêm das variáveis --status-color-* em assets/main.scss
   (mesma paleta usada em Stock/DisponibilityView.vue, para não duplicar). */
.status-btn-pending-delivery       { border-color: var(--status-color-pending-delivery); color: var(--status-color-pending-delivery); }
.status-btn-pending-pickup         { border-color: var(--status-color-pending-pickup); color: var(--status-color-pending-pickup); }
.status-btn-active                 { border-color: var(--status-color-active); color: var(--status-color-active); }
.status-btn-pending-company-pickup { border-color: var(--status-color-pending-company-pickup); color: var(--status-color-pending-company-pickup); }
.status-btn-pending-return         { border-color: var(--status-color-pending-return); color: var(--status-color-pending-return); }
.status-btn-completed              { border-color: var(--status-color-completed); color: var(--status-color-completed); }
.status-btn-scheduled              { border-color: var(--status-color-scheduled); color: var(--status-color-scheduled); }
.status-btn-unknown                { border-color: var(--status-color-unknown); color: var(--status-color-unknown); }

.status-btn-pending-delivery.is-active       { background: linear-gradient(90deg, var(--status-color-pending-delivery), var(--status-color-pending-delivery-light)); border-color: var(--status-color-pending-delivery); color: #fff; }
.status-btn-pending-pickup.is-active         { background: linear-gradient(90deg, var(--status-color-pending-pickup), var(--status-color-pending-pickup-light)); border-color: var(--status-color-pending-pickup); color: #fff; }
.status-btn-active.is-active                 { background: linear-gradient(90deg, var(--status-color-active), var(--status-color-active-light)); border-color: var(--status-color-active); color: #fff; }
.status-btn-pending-company-pickup.is-active { background: linear-gradient(90deg, var(--status-color-pending-company-pickup), var(--status-color-pending-company-pickup-light)); border-color: var(--status-color-pending-company-pickup); color: #fff; }
.status-btn-pending-return.is-active         { background: linear-gradient(90deg, var(--status-color-pending-return), var(--status-color-pending-return-light)); border-color: var(--status-color-pending-return); color: #fff; }
.status-btn-completed.is-active              { background: linear-gradient(90deg, var(--status-color-completed), var(--status-color-completed-light)); border-color: var(--status-color-completed); color: #fff; }
.status-btn-scheduled.is-active              { background: linear-gradient(90deg, var(--status-color-scheduled), var(--status-color-scheduled-light)); border-color: var(--status-color-scheduled); color: #fff; }
.status-btn-unknown.is-active                { background: linear-gradient(90deg, var(--status-color-unknown), var(--status-color-unknown-light)); border-color: var(--status-color-unknown); color: #fff; }

@media (max-width: 400px) {
  .status-btn {
    flex: 1 1 100%;
  }
}
</style>